export const frBackendMessages = {
  errors: {
    accountLocked: `Votre compte est temporairement verrouillé en raison de plusieurs tentatives de connexion infructueuses. Réessayez dans {{remaining_time}} minutes.`,
    accountLockedAttemptsRemaining: `Adresse e-mail ou mot de passe incorrect. {{attempts_left_until_lock}} restantes avant le verrouillage du compte.`,
    accountLockedOneMoreAttempt: `Email ou mot de passe incorrect. Une tentative supplémentaire verrouillera votre compte pendant 15 minutes.`,
    answerNotFound: `Aucune réponse trouvée pour la question : {{question_key}}.`,
    answerQuestionKeyInvalid: `question_key invalide. Le format doit être « question_1 » à « question_8 ».`,
    appleIapInvalidJson: `Charge utile JSON invalide`,
    appleIapMissingSignedPayload: `signedPayload manquant`,
    appleIapWebhookProcessingFailed: `Échec du traitement du webhook`,
    chatArchivalTaskFailed: `Échec de la mise en file de la tâche d'archivage : {{error}}`,
    chatCeleryTestFailed: `Échec de la mise en file des tâches de test Celery : {{error}}`,
    chatQueryTooLong: `La requête est trop longue pour être traitée.`,
    chatRulesRefreshFailed: `Échec de l'actualisation des règles de discussion : {{error}}`,
    chatSessionAlreadyClosed: `La session {{session_id}} est déjà fermée`,
    chatSessionCloseAllFailed: `Échec de la fermeture des sessions : {{error}}`,
    chatSessionCloseFailed: `Échec de la fermeture de la session : {{error}}`,
    chatSessionGetActiveFailed: `Échec de la récupération des sessions actives : {{error}}`,
    chatSessionNotFound: `Session de discussion introuvable`,
    chatStreamError: `Une erreur s'est produite dans le flux de discussion. Veuillez réessayer.`,
    decryptionFailed: `Impossible de déchiffrer les données stockées. Veuillez contacter le support.`,
    encryptionServiceNotConfigured: `Le service de chiffrement n'est pas correctement configuré. Veuillez contacter le support.`,
    expiredProviderToken: `Votre session de connexion Google ou Apple a expiré. Veuillez réessayer.`,
    fileDocxExceedsSizeLimit: `Le fichier DOCX dépasse la taille maximale autorisée.`,
    fileImageExceedsSizeLimit: `L'image dépasse la taille maximale autorisée.`,
    fileImageTypeNotAllowed: `Le type d'image {{subtype}} n'est pas autorisé.`,
    fileInsufficientPermissions: `Permissions insuffisantes.`,
    fileNotFound: `Fichier introuvable.`,
    filePdfExceedsSizeLimit: `Le fichier PDF dépasse la taille maximale autorisée.`,
    fileReadFailed: `Échec de lecture du fichier : {{error}}.`,
    fileSizeExceedsLimit: `La taille du fichier dépasse la limite maximale de {{max_files}} MB.`,
    fileTooManyFiles: `Trop de fichiers. Maximum {{max_size}} fichiers autorisés par upload.`,
    fileTooManyFilesAttached: `Trop de fichiers attachés. Maximum {{max_files}} fichiers par message.`,
    fileTypeNotAllowed: `Le type de fichier {{file_type}} n'est pas autorisé.`,
    fileUploadAzureFailed: `Échec du téléversement du fichier vers Azure`,
    fileUploadFailed: `Téléversement impossible : {{error}}`,
    googlePlayInvalidBase64Json: `Base64/JSON invalide : {{error}}`,
    googlePlayInvalidEnvelope: `Enveloppe invalide : {{error}}`,
    googlePlayMissingMessageIdOrData: `messageId ou données manquants`,
    googlePlayMissingRequiredFields: `Champs RTDN obligatoires manquants`,
    googlePlayPackageNameRequired: `Le nom du package est requis`,
    googlePlayPackageNotAllowed: `Le package {{package_name}} n'est pas autorisé`,
    googlePlayProcessingFailed: `Échec du traitement : {{error}}`,
    googlePlayProductIdRequired: `L'identifiant du produit est requis dans les détails d'achat`,
    googlePlayPurchaseDetailsRequired: `Les détails d'achat sont requis`,
    googlePlayPurchaseTokenRequired: `Le jeton d'achat est requis`,
    googlePlayPurchaseVerificationFailed: `Échec de la vérification de l'achat : {{message}}`,
    googlePlayPurchaseVerificationFailedUnexpected: `Échec de la vérification d'achat en raison d'une erreur inattendue.`,
    googlePlayServiceConfigurationError: `Erreur de configuration du service Google Play : {{error}}`,
    incorrectEmailOrPassword: `Email ou mot de passe incorrect.`,
    incorrectPassword: `Mot de passe incorrect.`,
    internalServerError: `Erreur interne du serveur.`,
    invalidProviderToken: `La connexion Google ou Apple n’a pas pu être vérifiée. Veuillez réessayer.`,
    invalidRefreshToken: `Refresh token invalide.`,
    invalidToken: `Token invalide.`,
    invalidTokenType: `Type de token invalide.`,
    notAuthenticated: `Utilisateur non authentifié.`,
    couldNotValidateCredentials: `Impossible de valider les identifiants.`,
    accountInactive: `Compte inactif ou programmé pour suppression.`,
    providerAuthFailed: `La connexion via votre fournisseur a échoué. Veuillez réessayer ou utiliser votre e-mail et votre mot de passe.`,
    unsupportedProvider: `Ce fournisseur de connexion n’est pas pris en charge.`,
    linkingRequired: `Cette identité sociale doit être associée à un compte HARVN existant avant de pouvoir continuer.`,
    accountLinkingFailed: `Nous n’avons pas pu associer cette identité sociale à votre compte HARVN. Vérifiez vos informations et réessayez.`,
    providerUnavailable: `La connexion sociale est temporairement indisponible. Veuillez utiliser votre e-mail et votre mot de passe.`,
    onboardingIncomplete: `Votre compte n’est pas encore entièrement configuré. Veuillez terminer les étapes requises avant de continuer.`,
    accountCompletionNotRequired: `Votre compte est déjà complet. Vous pouvez continuer à utiliser HARVN normalement.`,
    tokenExpired: `Le token a expiré.`,
    tokenRevoked: `Le token a été révoqué.`,
    tokenLimitExceeded: `Limite de tokens dépassée.`,
    debugTokenCheckFailed: `Erreur lors de la vérification du jeton : {{error}}`,
    passwordResetEmailFailed: `Impossible d'envoyer l'e-mail de réinitialisation du mot de passe. Veuillez réessayer plus tard.`,
    passwordSameAsCurrent: `Le nouveau mot de passe ne peut pas être identique à l'actuel`,
    passwordsDontMatch: `Les mots de passe ne correspondent pas.`,
    questionnaireNotFound: `Questionnaire introuvable.`,
    rateLimitExceeded: `Limite de taux dépassée: {{limit_str}}`,
    assistantPromptNotFound: `Invite assistant introuvable`,
    assistantPromptNotAuthorized: `Non autorisé à accéder à cette invite`,
    assistantPromptNotAuthorizedToActivate: `Non autorisé à activer cette invite`,
    assistantPromptNotAuthorizedToDelete: `Non autorisé à supprimer cette invite`,
    assistantPromptNotAuthorizedToUpdate: `Non autorisé à mettre à jour cette invite`,
    validationDateInvalid: `Format de date non valide.`,
    validationEmailInvalid: `Format d'adresse email invalide.`,
    validationFieldRequired: `Champ obligatoire.`,
    validationGeneric: `Erreur de validation.`,
    validationInvalidValue: `Valeur invalide.`,
    validationPasswordLength: `Le mot de passe doit contenir entre 8 et 40 caractères.`,
    validationStringTooLong: `Valeur trop longue.`,
    validationStringTooShort: `Valeur trop courte.`,
    validationTypeError: `Type non valide.`,
    validationValueOutOfRange: `Valeur hors limites autorisées.`,
    rateLimitRetryAfter: `Limite de taux atteinte. Veuillez réessayer {{retry_after_formatted}}.`,
    subscriptionAdminPrivilegesRequired: `Niveau d'accès administrateur requis.`,
    subscriptionAlreadyActive: `L'utilisateur possède déjà un abonnement actif.`,
    subscriptionCancelled: `Votre abonnement a été annulé. Merci de vous réabonner.`,
    subscriptionCancelFailed: `Échec de l'annulation de l'abonnement.`,
    subscriptionCannotDowngrade: `Un abonnement actif existe déjà — impossible de rétrograder.`,
    subscriptionCannotSwitchToSamePlan: `Impossible de sélectionner le même plan d'abonnement.`,
    subscriptionDaysAdvanceLimit: `Vous ne pouvez pas avancer de plus de 365 jours à la fois.`,
    subscriptionDayConsumptionFreemiumOnly: `La consommation journalière est réservée aux utilisateurs en freemium trial.`,
    subscriptionDaysMustBePositive: `Le nombre de jours utilisés doit être positif.`,
    subscriptionFreemiumActivationFailed: `Échec de l'activation de la période d'essai.`,
    subscriptionFreemiumExpired: `La période d'essai est expirée.`,
    subscriptionFreemiumTrialEnded: `Votre période d'essai est terminée. Merci de vous abonner.`,
    subscriptionFreemiumTokensExhausted: `Vous avez utilisé tous vos tokens d'essai. Merci de vous abonner pour continuer.`,
    subscriptionExpired: `Votre abonnement a expiré. Merci de vous réabonner.`,
    subscriptionInvalidPlanChoice: `Choix de plan invalide. Le plan doit être Mensuel ou Annuel.`,
    subscriptionInvalidStatus: `Statut d'abonnement non valide.`,
    subscriptionNoActiveSubscription: `Aucun abonnement actif trouvé.`,
    subscriptionNotEnoughTokensRemaining: `Tokens restants insuffisants.`,
    subscriptionPaymentConfigurationError: `Erreur de configuration de paiement. Veuillez contacter le support.`,
    subscriptionPaymentProcessingError: `Erreur de traitement du paiement : {{error}}.`,
    subscriptionPeriodEnded: `Votre période d'abonnement est terminée. Merci de vous réabonner.`,
    subscriptionStripeConfigurationError: `Erreur de configuration Stripe : {{error}}.`,
    subscriptionStripeNotAvailable: `Stripe n'est pas disponible.`,
    subscriptionStripeNotConfigured: `Stripe non configuré.`,
    subscriptionTrialNotInitialized: `Période d'essai non initialisée.`,
    subscriptionUserAlreadyHasActiveSubscription: `L'utilisateur possède déjà un abonnement actif.`,
    subscriptionNoStripeSubscriptionForBillingPortal: `Le mode de paiement ne peut être mis à jour que pour les abonnements actifs. Aucun abonnement actif trouvé.`,
    subscriptionNotFound: `Abonnement introuvable.`,
    subscriptionTokensMustBePositive: `Le nombre de tokens utilisés doit être positif.`,
    subscriptionWebhookInvalidPayload: `Charge utile invalide`,
    subscriptionWebhookInvalidSignature: `Signature invalide`,
    subscriptionWebhookMissingSignature: `En-tête stripe-signature manquant`,
    subscriptionWebhookSecretNotConfigured: `Secret de webhook non configuré`,
    tokenAlreadyUsed: `Token déjà utilisé.`,
    tokenNotFound: `Token introuvable.`,
    tooManyLoginAttempts: `Trop de tentatives de connexion. Réessayez dans {{retry_after}} secondes. {{attempts_left_until_lock}} restantes avant le verrouillage du compte.`,
    unexpectedError: `Une erreur inattendue est survenue. Veuillez réessayer plus tard.`,
    userAccountCreationFailed: `Impossible de créer le compte. Veuillez réessayer ou vous connecter si vous avez déjà un compte.`,
    userCannotDeleteSelf: `Les super utilisateurs ne peuvent pas se supprimer eux-mêmes.`,
    userDeletionFailed: `Échec de la programmation de la suppression du compte. Veuillez réessayer plus tard.`,
    userEmailAlreadyVerified: `Email déjà vérifié.`,
    userEmailExists: `Impossible de mettre à jour l'email. Veuillez en essayer un autre.`,
    userEmailNotVerified: `Adresse email non vérifiée.`,
    userEmailUpdateFailed: `Impossible de mettre à jour l'email. Veuillez en essayer un autre.`,
    userInactive: `Utilisateur inactif.`,
    userInsufficientPrivileges: `L'utilisateur ne dispose pas des privilèges nécessaires.`,
    userNotAllowed: `Utilisateur non autorisé.`,
    userNotFound: `Utilisateur introuvable.`,
    userPrivacyNotAccepted: `La Politique de Confidentialité doit être acceptée pour créer un compte.`,
    userTermsNotAccepted: `Les Conditions de Service doivent être acceptées pour créer un compte.`,
    userWithEmailNotFound: `Aucun utilisateur trouvé avec cet email.`,
    userWithIdNotFound: `Aucun utilisateur trouvé avec cet identifiant.`,
    userWithUsernameNotFound: `Aucun utilisateur trouvé avec ce nom d'utilisateur.`,
  },
  success: {
    accountScheduledForDeletion: `Votre compte a été programmé pour suppression.`,
    fileDeleted: `Fichier supprimé avec succès`,
    fileUploaded: `Fichier téléversé avec succès vers Azure Blob Storage`,
    fileUploadedToSession: `Fichier téléversé avec succès vers le stockage de session`,
    fileUploadUrlGenerated: `URL de téléversement générée avec succès`,
    loggedOut: `Déconnexion réussie`,
    passwordRecoveryEmailSent: `E-mail de récupération du mot de passe envoyé`,
    passwordUpdated: `Mot de passe mis à jour avec succès`,
    sessionClosed: `Session {{session_id}} fermée et mise en file pour archivage`,
    userDeleted: `Utilisateur supprimé avec succès`,
    userVerified: `Utilisateur vérifié avec succès`,
    verificationEmailSent: `E-mail de vérification renvoyé avec succès`,
  },
} as const;
